export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1704345911144-dd1b0b6d1db2?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  tattooProcess: "https://images.pexels.com/photos/13716808/pexels-photo-13716808.jpeg?auto=compress&cs=tinysrgb&fit=crop&w=900&h=1200",
  collaboration: "/brand/series-tattoo-session.png",
  shopExterior: "https://images.unsplash.com/photo-1760877611905-0f885a3ce551?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  shopInterior: "https://images.unsplash.com/photo-1775135981378-4e7c1767436d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  cityNight: "https://images.unsplash.com/photo-1716118143256-bad145740ac4?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  citySkyline: "https://images.unsplash.com/photo-1673934149508-318260ef31f2?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  jordy: "/brand/jordy.webp",
};

// Brand assets (served from /public/brand)
export const BRAND = {
  wordmark: "/brand/tattooed-abroad-wordmark-clean.png",
  script: "/brand/journeys-written-in-skin-script.png",
  star: "/brand/sailor-star.png",
  web: "/brand/corner-web.png",
  initials: "/brand/ta-initials.png",
  flameJ: "/brand/custom-flame-j.png",
  flameT: "/brand/exact-flame-t.png",
};

export const CONTACT_EMAIL = "info@tattooedabroad.com";

export const HERO_DESCRIPTION =
  "Tattooed Abroad brings tattoo artists and clients from around the world together to explore travel, transformation, cultural exchange, and the bonds created through journeys written in skin.";

export const SERIES_INTRO =
  "Most tattoo content focuses on technique, finished artwork, celebrity artists, or shock value. Tattooed Abroad uses tattooing as a doorway into travel, identity, culture, traditions, belief, and personal transformation.";

export const SERIES_INTRO_2 =
  "Every episode gives equal attention to an artist and client from different countries while also exploring the tattoo shop, its environment, and the owner's vision behind it. Their collaboration—and the trust required to create something permanent—is the emotional center of the story.";

export const EPISODE_CHAPTERS = [
  { n: "01", title: "Artist + Client", body: "Where the artist and client come from, how they found each other, and what brought them together across borders." },
  { n: "02", title: "The shop", body: "A tour with the shop owner reveals the space, its history, its artists, and the tattoo culture surrounding it." },
  { n: "03", title: "The collaboration", body: "The client's story and the artist's vision meet as the meaning, placement, design, and price take shape." },
  { n: "04", title: "The tattoo", body: "The physical process drives the story. Every tattoo is started and completed during the shoot." },
  { n: "05", title: "The reveal", body: "The finished work becomes a permanent expression of two people, two cultures, one shared journey, and the connection formed between them." },
];

export const PEOPLE = [
  { n: "01", label: "The Artist", title: "A distinctive style. A story worth telling.", body: "Established and emerging artists bring a distinctive style, vibe, individual perspective, and a compelling personal story. Each episode explores what led the artist to tattooing and the cultural, creative, personal, and traditional influences that shape their work." },
  { n: "02", label: "The Client", title: "A personal reason to make something permanent.", body: "Whether receiving their first tattoo or adding to an established collection, the client has a meaningful reason for choosing the artist and an engaging personal story that carries equal weight in the episode." },
  { n: "03", label: "The Shop Owner", title: "The guide to a\ncreative world.", body: "Through a tour of the tattoo shop, the owner introduces its environment, identity, history, artists, philosophy, community, and place within the local tattoo culture." },
];

export const SEASON_STATS = [
  { value: "11", label: "Episodes" },
  { value: "6", label: "Weeks or less" },
  { value: "1", label: "New film weekly" },
];

export const SEASON_ONE =
  "Season One consists of an extended premiere and ten 45-minute episodes, all filmed in Ho Chi Minh City. The goal is to complete principal photography in six weeks or less, finish the entire season before launch, and release one episode per week.";

export const SEASON_ONE_2 =
  "Every episode centers on a tattoo started and completed during filming. Each story concludes with a meaningful reveal.";

export const JORDY_BIO_1 =
  "Jordy “Comes Alive” Trachtenberg is an American social-media personality, writer, and content creator based in Ho Chi Minh City, Vietnam.";

export const JORDY_BIO_2 =
  "His work exploring culture, food, travel, and unexpected human stories has attracted more than 100,000 followers and generated 26 million views and 1.4 million likes. He produced 25 episodes of Relocated and is the creator, host, and executive producer of Tattooed Abroad.";

export const JORDY_BIO_3 =
  "In each episode, Jordy provides a concise on-camera introduction, voice-over when context is needed, and a closing reflection. Jordy guides viewers through each story without taking focus away from the artist, client, shop owner, or the tattooing process itself.";

export const JORDY_STATS = [
  { value: "100,000+", label: "Followers" },
  { value: "26M", label: "Views" },
  { value: "1.4M", label: "Likes" },
];

export const KICKSTARTER_BODY =
  "Tattooed Abroad will launch through a 30-day Kickstarter campaign. Backing the campaign helps fund production and post-production for the complete 11-episode first season before its weekly public release.";

export const KICKSTARTER_BODY_2 =
  "Follow the social channels for previews, footage, and stories. Join the list below and we'll notify you the moment the campaign goes live.";

export const CASTING_BODY =
  "We want to hear from international artists, clients with meaningful stories, tattoo shops, cultural partners, press, and future collaborators.";
